/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React from 'react';
import {View, StyleSheet, Pressable, Dimensions} from 'react-native';
import {Card, Badge} from 'react-native-elements';

const CatalogCard = (props) => {
const unread_updates = String(props.unread + "+ New Updates!");
return (
<Pressable
      onPress={() => {props.onPress()}}
      style={({ pressed }) => [
          { opacity: pressed ? 0.5 : 1.0 },
          styles.catalogContainer
        ]}>
     <Card
     containerStyle={{borderRadius: 11/2}}
     >
     <Card.Title>{props.title}</Card.Title>
     <Card.Divider />
     <View style={{alignItems:'center'}}>
     <Card.Image
      transition={true}
      source={{
      uri: props.image,
      }}
      style={props.splitScreen? styles.catalogImageScaled : styles.catalogImage}
      />
      <Card.FeaturedSubtitle
      style={{color: 'black', marginTop: 10}}
      >
      {props.description}
      </Card.FeaturedSubtitle>
      {props.unread > 0 ?
      <Badge value={unread_updates} status="error" style={styles.updateBadge} />
      :
      <></>
      }
      </View>
      </Card>
      </Pressable>
)
}
const entireScreenHeight = Dimensions.get('window').height;
const entireScreenWidth = Dimensions.get('window').width;
const styles = StyleSheet.create({
updateBadge: {
paddingTop: 8,
paddingBottom: 8,
},
catalogImage: {
height: entireScreenHeight / 2,
width: 'auto',
aspectRatio: 3/4,
resizeMode: 'contain',
},
catalogImageScaled: {
height: entireScreenHeight / 3.5,
width: 'auto',
aspectRatio: 3/4,
resizeMode: 'contain',
},
catalogContainer: {
marginBottom: 25,
borderRadius: 11/2,
alignItems: 'center',
},
});

export default CatalogCard;